<template>
  <div class="u-modal" :class="{ 'active': showModal }">
    <div class="u-modal__background"></div>
    <div class="u-modal__container">
      <div class="u-modal__header">
        <!-- <div class="u-modal__title">Modal title</div> -->
        <div @click="showModal=false" class="u-modal__close">
          <i class="fas fa-times"></i>
        </div>
      </div>
      <div class="u-modal__body">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-3 col-sm-12">
              <strong>
                <label
                  class="form-label"
                  for="input-example-1"
                >{{ getCaption("caption.card_number") }}</label>
              </strong>
            </div>
            <div class="col-9 col-sm-12 text-center flex-centered">
              <strong>{{ $parent.formatString(number, [4,8,12], " ") }}</strong>
            </div>
          </div>
        </div>
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-3 col-sm-12">
              <strong>
                <label
                  class="form-label"
                  for="input-example-1"
                >{{ getCaption("caption.card_name") }}</label>
              </strong>
            </div>
            <div class="col-9 col-sm-12">
              <input
                class="form-input rounded text-center focus-purple"
                type="text"
                :placeholder="getCaption('caption.card_name')"
                v-on:input="onChangeHandler('name', $v.name)"
                :class="{ 'is-error': $v.name.$error }"
                v-model="name"
              >
              <span
                v-if="!$v.name.serverFailed"
                class="error-msg__data"
              >{{ this.getErrorMsg('name')[0] }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="u-modal__footer">
        <div v-if="submitStatus === 'PENDING'" class="loader--sm"></div>
        <div v-else class="u-modal__actionBtn" @click="editCard()">
          <span>{{ this.getCaption("caption.edit_card") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "@/mixins/Form.js";
import CardService from "@/services/CardService.js";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [Form],

  data() {
    return {
      name: "",
      id: "",
      number: "",

      showModal: false
    };
  },

  validations: {
    name: {
      required,
      serverFailed: function() {
        return !this.hasServerError("name");
      }
    }
  },

  methods: {
    init(card) {
      this.name = card.name;
      this.id = card.id;
      this.number = card.number;
      this.showModal = true;
      this.selectedCard = card;
      this.serverErrors = [];
    },

    editCard() {
      if (this.selectedCard.name == this.name) this.showModal = false;
      else this.onSubmit();
    },

    serverRequest: CardService.editCard,

    successHandler() {
      this.showModal = false;
      this.$parent.getCardList();
    },

    fatalErrorHandler() {
      this.showModal = false;
      this.$parent.getCardList();
    },

    createJsonData() {
      const data = JSON.parse("{}");
      data.id = this.id;
      data.name = this.name;
      return data;
    }
  }
};
</script>
